<template>
  <div class="s-detail container">
    <div class="box">
      <el-page-header @back="$router.go(-1)" :content="typeText + '完成情况'">
      </el-page-header>
      <el-form
        :model="searchForm"
        ref="searchForm"
        class="search_form"
        :inline="true"
        size="small"
      >
        <el-form-item
          prop="taskId"
          label="所属实战"
          v-show="$route.query.type == 'works'"
        >
          <el-select
            v-model="searchForm.taskId"
            placeholder="请选择"
            @change="getList"
          >
            <el-option
              v-for="item in taskList"
              :key="item.taskId"
              :label="item.title"
              :value="item.taskId"
            >
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>

      <el-table
        class="list"
        :data="list"
        height="calc(100% - 50px - 55px)"
        :default-sort="{ prop: 'complete', order: 'ascending' }"
      >
        <el-table-column
          :prop="taskType == 'teamWorks' ? 'teamIcon' : 'avatar'"
          label="头像"
          align="center"
        >
          <template slot-scope="scope">
            <el-image
              style="width: 44px; height: 44px"
              :src="
                taskType == 'teamWorks' ? scope.row.teamIcon : scope.row.avatar
              "
              fit="cover"
            ></el-image>
          </template>
        </el-table-column>
        <el-table-column
          :prop="taskType == 'teamWorks' ? 'captainName' : 'nickName'"
          :label="taskType == 'teamWorks' ? '队长' : '姓名'"
          align="center"
        >
        </el-table-column>
        <el-table-column
          :prop="taskType == 'teamWorks' ? 'teamName' : 'sno'"
          :label="taskType == 'teamWorks' ? '团队' : '学籍号'"
          align="center"
        >
        </el-table-column>
        <!-- <el-table-column
          prop="teamName"
          label="所属团队"
          align="center"
          v-if="taskType != 'teamWorks'"
        >
          <template slot-scope="scope">
            {{ scope.row.teamName || "无" }}
          </template>
        </el-table-column> -->
        <el-table-column prop="complete" label="是否完成" align="center" sortable>
          <template slot-scope="scope">
            <el-tag
              type="success"
              size="medium"
              effect="plain"
              v-show="scope.row.complete"
              >已完成</el-tag
            >
            <el-tag
              type="warning"
              size="medium"
              effect="plain"
              v-show="!scope.row.complete"
              >未完成</el-tag
            >
          </template>
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>

<script>
import { chapterStatisticsDetail } from "@/api/chapter";
import { practiceList } from "@/api/practice";

export default {
  data() {
    return {
      searchForm: {
        classChapterId: this.$route.query.classChapterId,
        taskId: null,
      },
      total: 0,
      list: [],
      taskList: [],
    };
  },
  activated() {
    if (this.$route.query.type == "works") this.getTaskList();
    else this.getList();
  },
  computed: {
    taskType() {
      if (this.$route.query.type != "works") return;
      let task = this.taskList.find((item) => {
        return item.taskId == this.searchForm.taskId;
      });

      return task && task.taskType == "PERSONAL" ? "works" : "teamWorks";
    },
    typeText() {
      let type = this.$route.query.type;
      if (type == "video") return "微课";
      else if (type == "ppt") return "PPT";
      else if (type == "test") return "练习";
      else if (type == "works") return "实操";
    },
  },
  methods: {
    getList() {
      let classChapterId = this.$route.query.classChapterId;
      let type = this.taskType || this.$route.query.type;
      this.$loading.show();
      chapterStatisticsDetail({
        classChapterId,
        type,
        taskId: this.searchForm.taskId,
      }).then((res) => {
        this.$loading.hide();
        if (res.code == 0) {
          this.list = res.data;
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    //   实战列表
    getTaskList() {
      practiceList(this.searchForm).then((res) => {
        if (res.code == 0) {
          this.taskList = res.data;
          this.searchForm.taskId = res.data[0].taskId;
          this.getList();
        } else {
          this.$message.error(res.msg);
        }
      });
    },
  },
};
</script>

<style lang="less" scoped>
.s-detail {
  height: 100%;

  .box {
    padding: 25px 35px;
    margin: 30px auto;
    height: calc(100% - 60px);
    background-color: rgb(255, 255, 255);
    ::v-deep .el-page-header {
      margin-bottom: 20px;
      .el-page-header__content {
        font-size: 16px;
      }
    }

    .search_form {
      text-align: left;
      .back-btn {
        margin-right: 30px;
        padding: 8px 0;
      }
      .el-form-item {
        margin-right: 25px;
      }
    }
    ::v-deep .list {
      margin-top: 5px;
      overflow: auto;
      .is-leaf {
        color: #fff;
        background-color: teal;
      }
    }
  }
}
</style>